import { Component, OnInit, Input, AfterViewInit, OnChanges } from '@angular/core';
import { BuchungResult } from 'src/app/api/buchung-result';

@Component({
  selector: 'app-buchungen-header',
  templateUrl: './buchungen-header.component.html',
  styleUrls: ['./buchungen-header.component.scss']
})
export class BuchungenHeaderComponent implements OnInit, OnChanges {
  @Input() public buchungResult: BuchungResult;
  public status: string;
  public ausgaben: string;
  public einnahmen: string;
  public ergebnis: string;
  public buchungCount: number;

  constructor() { 
  } 

  ngOnInit(): void {
  }

  ngOnChanges(): void {
    this.ausgaben = this.buchungResult.ausgaben;
    this.einnahmen = this.buchungResult.einnahmen;
    this.ergebnis = this.buchungResult.ergebnis;
    this.buchungCount = this.buchungResult.count;
    if (+this.ergebnis < 0) {
      this.status = '#fff2f2';  // danger-100
    }
    else {
      this.status = '#f0fff5';  // success-100
    }
  }
}
